module.exports = __webpack_public_path__ + "img/networking-services.b66eac0d.jpg";